export default __webpack_public_path__ + "static/media/undraw_contract_uy56.330e5912.png";